module.exports = __webpack_public_path__ + "static/media/bi_data.8b75642a.svg";